import { Modal } from "antd";
import { Flex, Box, Textarea } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import { useForm } from "react-hook-form";
import FormRecorrencia from "./components/FormRecorrencia/index";
import useSaveManutencoes from "core/features/manutencao/hooks/useSaveManutencoes";
import { ManutencaoForm } from "core/features/manutencao/typings/index";
import { showSuccess, showErrorAxios } from "infra/helpers/alerta";
import { useEffect } from "react";
import AdicionarEquipamento from "./components/AdicionarEquipamento/index";
import FormAnexarArquivo from "./components/FormAnexarArquivo/index";
import { useManutencaoDetalhe } from "core/features/manutencao/hooks/useManutencaoDetalhe";
import { useLoading } from "components/GlobalLoading/index";
import InputAutocomplete from "components/Input/InputAutocomplete";
import usePessoasAutocomplete from "core/features/pessoas/hooks/usePessoasAutocomplete";
import moment from "moment";

interface ModalNovoPlanoManutencaoProps {
  visible: boolean;
  onClose: () => any;
  refetchList?: () => any;
  id?: string;
}

const defaultValuesManutencoesForm: Partial<ManutencaoForm> = {
  equipamentosIds: [undefined],
  tipoRecorrencia: "unica",
  data: moment().format("YYYY-MM-DD"),
  recorrencia: true,
};
export default function ModalNovoPlanoManutencao({
  onClose,
  visible,
  refetchList,
  id,
}: ModalNovoPlanoManutencaoProps) {
  const { data, isLoading, isFetching } = useManutencaoDetalhe(id);
  const { handleSubmit, control, setValue, watch, reset } =
    useForm<ManutencaoForm>({
      defaultValues: defaultValuesManutencoesForm,
    });
  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveManutencoes();

  const onSubmit = async (data: ManutencaoForm) => {
    handleSave(data, {
      onSuccess: () => {
        setTimeout(() => {
          showSuccess().then(() => onClose());
        }, 250);
        refetchList?.();
      },
      onError: (err) => {
        showErrorAxios(err);
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({
        anexarArquivos: !!data.arquivos.length,
        arquivos: data.arquivos,
        files: data.arquivos.map((arquivo) => ({
          ...arquivo,
          name: arquivo.nome,
        })),
        data: data.dataPrevistaInicial,
        observacao: data.observacao || "",
        id: data.id,
        nome: data.nome,
        intervaloRepeticao: data.intervaloRepeticao || undefined,
        tipoIntervaloRepeticaoId: data.tipoIntervaloRepeticaoId || undefined,
        responsavelTecnicoId: data.responsavelTecnico.id,
        responsavelTecnicoNome: data.responsavelTecnico.nome,
        equipamentosIds: data.equipamentos.map((equipamento) => equipamento.id),
        recorrencia: true,
        tipoRecorrencia: data.tipoIntervaloRepeticaoId ? "recorrente" : "unica",
      });
    }
  }, [data, reset]);

  useEffect(() => {
    if (!visible) {
      reset(defaultValuesManutencoesForm);
    }
  }, [reset, visible]);
  const form = watch();

  useLoading(isLoading || isFetching);

  return (
    <Modal
      destroyOnClose
      width={"600px"}
      onCancel={onClose}
      centered
      title={id ? "Editar plano de manutenção" : "Novo plano de manutenção"}
      visible={visible}
      footer={
        <Flex justifyContent="end" gap={4}>
          <OutlineButton onClick={onClose}> Fechar</OutlineButton>
          <PrimaryButton
            isLoading={isLoadingSave}
            onClick={() => handleSubmit(onSubmit)()}
          >
            Salvar
          </PrimaryButton>
        </Flex>
      }
    >
      <form onSubmit={(e) => handleSubmit(onSubmit)(e)}>
        <Box as={Row} gutter={16}>
          <Box as={Col} mb={4} xs={24}>
            <Field
              label="Nome do plano manutenção"
              name="nome"
              rules={{
                required: "Informe o nome",
              }}
              inputProps={{ type: "text" }}
              control={control}
            />
          </Box>
        </Box>
        <Box as={Row} gutter={16}>
          <Box as={Col} mb={4} xs={24}>
            <Field
              label="Responsável Técnico"
              name="responsavelTecnicoNome"
              rules={{
                required: "Informe o responsável técnico",
              }}
              inputProps={{ type: "text" }}
              control={control}
              render={({ field }) => (
                <InputAutocomplete
                  onSelect={(v) => setValue("responsavelTecnicoId", v)}
                  onType={field.onChange}
                  useDataHook={usePessoasAutocomplete}
                  textValue={field.value}
                  placeholder="Digite o nome da pessoa ou escolha uma na lista"
                />
              )}
            />
          </Box>
        </Box>
        <Box mb={4}>
          <Field
            label="Observação"
            name="observacao"
            inputProps={{ type: "text" }}
            control={control}
            render={({ field, isInvalid }) => (
              <Textarea
                isInvalid={isInvalid}
                className="chakra-input"
                rows={4}
                resize="none"
                placeholder="Digite..."
                {...field}
              />
            )}
          />
        </Box>
        <AdicionarEquipamento
          control={control}
          form={form}
          setValue={setValue}
        />
        <FormRecorrencia control={control} form={form} />
        <FormAnexarArquivo form={form} control={control} setValue={setValue} />
      </form>
    </Modal>
  );
}
